<template>
    <div class="row">

        <div class="col-lg-8 col-lg-offset-2 col-xs-12 content">
            <CreditInfo />
        </div>

        <div class="col-lg-2 col-lg-offset-2 col-xs-12 block content">
            <UserMenu />
        </div>

        <div class="col-lg-6 col-xs-12 block content">
            <div class="spinner" v-if="!api_key">
                <div class="double-bounce1"></div>
                <div class="double-bounce2"></div>
            </div>
            <div class="setting" v-if="api_key">
                <h2>Developer</h2>
                <div class="row">
                    <div class="col-xl-12 col-xs-12">
                        <div class="row info-form">
                            <form id="email-form" @submit.prevent="copyApiKey" name="email-form" data-name="Email Form">

                                <div class="col-xl-12 col-xs-12">
                                    <div class="field">
                                        <input type="text" :value="api_key" class="input-form" id="api-key" readonly>
                                        <label for="full_name">Api Key</label>
                                    </div>
                                </div>
                                <div class="col-xl-12 col-xs-12">
                                    <flash-message class="large"></flash-message>
                                    <input type="submit" value="Copy Api Key" class="btn large-btn bold">
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import CreditInfo from '@/components/CreditInfo.vue'
import UserMenu from '@/components/UserMenu.vue'
import PreviousChargeTable from '@/components/PreviousChargeTable.vue'
import UpdateCardInfo from '@/components/UpdateCardInfo.vue'

export default {
  name: 'developer',
  components: {
    CreditInfo,
    UserMenu,
    PreviousChargeTable,
    UpdateCardInfo
  },
  mounted () {
    this.$http.get('/api/lead/api_key').then((res) => {
      this.api_key = res.body['access_token']
    })
  },
  data () {
    return {
      api_key: false
    }
  },
  methods: {
    copyApiKey () {
      let copyApi = document.querySelector('#api-key')
      copyApi.setAttribute('type', 'text') // 不是 hidden 才能複製
      copyApi.select()

      try {
        var successful = document.execCommand('copy')
        var msg = successful ? 'successful' : 'unsuccessful'
        this.$notify({
          group: 'foo',
          title: `${msg}`,
          type: 'success',
          duration: 10000
        })
      } catch (err) {
        this.$notify({
          group: 'foo',
          title: `${msg}`,
          text: 'please copy your api key manually',
          type: 'error',
          duration: 10000
        })
      }

      /* unselect the range */
      copyApi.setAttribute('type', 'text')
      window.getSelection().removeAllRanges()
    }
  }
}
</script>
